module.exports = __webpack_public_path__ + "img/MGH-Gion-2.739e48a6.jpg";